import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import {MODALS} from 'ducks/bookingSets';
import {
  DepositSummaryBasicInformation,
  DepositSummaryDetails
} from './components';

import './styles.css';

class DepositSummaryDetailModal extends React.Component<any> {
  render() {
    const {depositSummary, data: {locationRef, bookingSetId}} = this.props;

    return (
      <Modal
        className="DepositSummaryDetailModal"
        show={true}
        type={Modal.SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Deposit Summary" />
        <Modal.Body>
          <DepositSummaryBasicInformation depositSummary={depositSummary} />
          <div className="DepositSummary__sections">
            <DepositSummaryDetails
              depositSummary={depositSummary}
              bookingSetId={bookingSetId}
              locationRef={locationRef}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withModal(MODALS.DEPOSIT_SUMMARY_DETAIL_MODAL)(
  DepositSummaryDetailModal
);
